export default "__VITE_ASSET__CBQ0nLHk__"